import { Images } from '../../../../constants'

export const SUBJECT_CONTENT = {
  options: ['SS1', 'SS2', 'SS3'],

  content: [
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
    {
      img: Images.calculator,
      subject: 'mathematics',
      chapters: 12,
      bgColor: '#FFF0E1',
      color: '#FCAB5E',
    },
    {
      img: Images.discovery,
      subject: 'Physics',
      chapters: 16,
      bgColor: '#E9E3FE',
      color: '#8A70D6',
    },
    {
      img: Images.science,
      subject: 'Chemistry',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#579BE4',
    },
    {
      img: Images.science,
      subject: 'Geography',
      chapters: 14,
      bgColor: '#E5F3FE',
      color: '#8C1BAB',
    },
  ],
}
